<template>
  <div class="study">
    <div class="study-head">
      <div class="head">
        <!-- <div class="back-wrapper" @click="goBack">
          <svg-icon iconClass="back" class="back-icon"></svg-icon>
        </div> -->
        <div class="head-content">
          <div class="avatar">
            <svg-icon :iconClass="avatarCls" class="avatar-icon"></svg-icon>
          </div>
          <div class="title">{{ info.nickName }}</div>
        </div>
      </div>
      <div class="head-bg">
        <img :src="info.reportImageUrl" alt="" class="head-bg-img" />
        <div class="star-one" :class="{ active: info.score >= 1 }"></div>
        <div class="star-two" :class="{ active: info.score >= 2 }"></div>
        <div class="star-three" :class="{ active: info.score >= 3 }"></div>
        <div class="trophy"></div>
      </div>
    </div>
    <div class="content">
      <div class="head">
        <div class="title">{{ info.chapterName }}</div>
      </div>
      <div class="sutdy-time">
        <div class="item">
          <div class="item-num">
            <div class="num">{{ info.totalChapter }}</div>
            <div class="num-text">节</div>
          </div>
          <div class="item-text">累计上课</div>
        </div>
        <div class="item">
          <div class="item-num">
            <div class="num">{{ info.totalQuestion }}</div>
            <div class="num-text">个</div>
          </div>
          <div class="item-text">累计练习</div>
        </div>
        <div class="item">
          <div class="item-num">
            <div class="num">{{ info.totalChapterQuestion }}</div>
            <div class="num-text">次</div>
          </div>
          <div class="item-text">本节练习</div>
        </div>
      </div>
      <div class="line"></div>
      <!-- 数独特有 -->
      <div class="du-statistics" v-if="info.classType == 2">
        <div class="du-title">本节做题统计</div>
        <div class="du-main">
          <div class="du-item">
            <div class="du-item-top">{{ info.rateOnceRight }}%</div>
            <div class="du-item-b">
              正确率
            </div>
          </div>
          <div class="du-item">
            <div class="du-item-top" v-if="info.speedMinutes < 1">
              {{ info.speedSeconds }}<span>秒</span>
            </div>
            <div
              class="du-item-top"
              v-if="info.speedMinutes > 0 && info.speedSeconds < 1"
            >
              {{ info.speedMinutes }}<span>分</span>
            </div>
            <div
              class="du-item-top"
              v-if="info.speedMinutes > 0 && info.speedSeconds > 0"
            >
              {{ info.speedMinutes }}<span>分</span>{{ info.speedSeconds
              }}<span>秒</span>
            </div>
            <div class="du-item-b">
              平均时间
            </div>
          </div>
          <div class="du-item">
            <div class="du-item-top" v-if="info.speedMinMinutes < 1">
              {{ info.speedMinSeconds }}<span>秒</span>
            </div>
            <div
              class="du-item-top"
              v-if="info.speedMinMinutes > 0 && info.speedMinSeconds < 1"
            >
              {{ info.speedMinMinutes }}<span>分</span>
            </div>
            <div
              class="du-item-top"
              v-if="info.speedMinMinutes > 0 && info.speedMinSeconds > 0"
            >
              {{ info.speedMinMinutes }}<span>分</span>{{ info.speedMinSeconds
              }}<span>秒</span>
            </div>
            <div class="du-item-b">
              最短时间
            </div>
          </div>
        </div>
      </div>
      <div class="chart-wrapper">
        <div class="chart-head">
          <div class="title">知识目标</div>
          <ul class="list">
            <li
              class="item"
              v-for="(item, index) in info.knowledgePoint"
              :key="index"
            >
              <svg-icon iconClass="tick" class="tick-icon"></svg-icon>
              <div class="item-text">
                {{ item }}
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="chart-wrapper" v-if="info.classType != 2">
        <div class="chart-head">
          <div class="title">思维目标</div>
          <ul class="list">
            <li
              class="item"
              v-for="(item, index) in info.introduction"
              :key="index"
            >
              <svg-icon iconClass="tick" class="tick-icon"></svg-icon>
              <div class="item-text">
                {{ item }}
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="chart-wrapper" v-if="info.userAudioUrl">
        <div class="chart-head">
          <div class="title">{{ info.nickName }}本节课的精彩讲解：</div>
          <div class="list">
            <div class="record-sound" @click="recordPlay">
              <voice-play
                ref="voicePlay"
                :url="info.userAudioUrl"
                :class="{ active: isPlay }"
              ></voice-play>
              <span>{{ info.userAudioPlayTime / 1000 }}″</span>
            </div>
          </div>
        </div>
      </div>
      <div class="chart-wrapper">
        <div class="chart-head">
          <div class="title">
            <div>
              <span>积木AI课</span>邀你和<span>{{ info.nickName }}</span
              >小朋友，
            </div>
            <div>
              一起探索神秘好玩的{{
                info.classType == 2 ? "少儿数独" : "数学思维"
              }}。
            </div>
          </div>
          <div class="code">
            <img src="./code.jpg" class="code-img" />
          </div>
          <div class="share-btn">
            <div class="arrow"></div>
            <div class="share-btn-text">长按识别二维码</div>
            <div class="arrow"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="footer">
      <div class="btn">
        <div class="btn-text">分享学习成绩</div>
        <div class="btn-score">
          <div class="score">+3</div>
          <svg-icon iconClass="score" class="score-icon"></svg-icon>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import wx from "weixin-js-sdk";
import { ERROR_OK } from "../../request/http";
import { getStudyInfo, getAppId, getSdk } from "../../request/api/study";
import VoicePlay from "../../components/voice-play/voice-play";
export default {
  name: "siwei",
  components: {
    VoicePlay
  },
  computed: {
    avatarCls() {
      let cls = "";
      if (this.info.sex === 1) {
        cls = "man";
      } else {
        cls = "nv";
      }
      return cls;
    }
  },
  data() {
    return {
      info: {},
      isPlay: false,
      visible: false
    };
  },
  created() {
    this.chapterId = this.$route.query.chapterId;
    this.classId = this.$route.query.classId;
    this.userId = this.$route.query.userId;
    this.getInfo();
    if (
      navigator.userAgent.toLowerCase().match(/MicroMessenger/i) ==
      "micromessenger"
    ) {
      this.getAppIdInfo();
    }
  },
  mounted() {},
  methods: {
    recordPlay() {
      if (this.isPlay) {
        return;
      }
      this.isPlay = true;
      let audio = this.$refs.voicePlay.play();
      audio.play();
      audio.addEventListener("ended", () => {
        this.isPlay = false;
      });
      // this.$bridge.callHandler("voicePlay", this.info.userAudioUrl, () => {
      //   this.isPlay = false;
      // });
    },
    async getAppIdInfo() {
      let { code, data } = await getAppId({});
      if (code === ERROR_OK) {
        console.log(data);
        const appId = data.appId;
        let timestamp = Math.floor(+new Date() / 1000);
        let nonceStr = timestamp + "1";
        let url = window.location.href.split("#")[0];
        let { code: sdkCode, data: sdkData } = await getSdk({
          timestamp,
          nonceStr,
          url,
          appId
        });
        if (sdkCode === ERROR_OK) {
          const signature = sdkData.signature;
          await wx.config({
            debug: false,
            appId,
            timestamp,
            nonceStr,
            signature,
            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"]
          });
          wx.error(res => {
            console.log(res);
          });
          wx.ready(() => {
            this.updateAppMessageShareData();
            this.updateTimelineShareData();
          });
        }
      }
    },
    updateAppMessageShareData() {
      let title = "学习报告";
      if (this.info.nickName) {
        title = `${this.info.nickName}的学习报告`;
      }
      let desc = `听听我家${this.info.nickName}宝贝讲题《${this.info.chapterName}》`;
      if (this.info.shareIntro) {
        desc = this.info.shareIntro;
      }
      wx.updateAppMessageShareData({
        title,
        desc,
        link: window.location.href,
        imgUrl: `${this.info.reportImageUrl}`,
        success() {
          console.log("分享成功");
        }
      });
    },
    updateTimelineShareData() {
      let title = "学习报告";
      if (this.info.nickName) {
        title = `${this.info.nickName}的学习报告`;
      }
      let desc = `听听我家${this.info.nickName}宝贝讲题《${this.info.chapterName}》`;
      if (this.info.shareIntro) {
        desc = this.info.shareIntro;
      }
      wx.updateTimelineShareData({
        title,
        desc,
        link: window.location.href,
        imgUrl: `${this.info.reportImageUrl}`,
        success() {
          console.log("分享成功");
        }
      });
    },
    async getInfo() {
      this.visible = true;
      let { code, data } = await getStudyInfo({
        chapterId: this.chapterId,
        classId: this.classId,
        userId: this.userId
      });
      if (code === ERROR_OK) {
        data.speedMinMinutes = Math.floor(data.valueAnswerSpeedMinMy / 60);
        data.speedMinSeconds =
          data.valueAnswerSpeedMinMy - data.speedMinMinutes * 60;
        data.speedMinutes = Math.floor(data.valueAnswerSpeedMy / 60);
        data.speedSeconds = data.valueAnswerSpeedMy - data.speedMinutes * 60;
        this.info = data;
      }
      this.visible = false;
    }
  }
};
</script>
<style lang="stylus" scoped>
.study
    display flex
    flex-direction column
    position: fixed
    z-index: 100
    top: 0
    left: 0
    bottom: 0
    right: 0
    overflow-y auto
    background: #fff
    .study-head
      position relative
      height 480px
      flex-grow:0;
      flex-shrink:0;
      .head-bg
        position absolute
        left 0
        top 0
        width 100%
        height 480px
        z-index -1
        .head-bg-img
          position absolute
          left 0
          top 0
          z-index -1
          width 100%
          height 480px
        .trophy
          position absolute
          left 50%
          bottom 44px
          transform translateX(-50%)
          width 136px
          height 123px
          background url('./trophy.png') no-repeat;
          background-size cover
        .star-one
          position absolute
          left 260px
          bottom 160px
          width 57px
          height 57px
          background url('./star-s-g.png') no-repeat;
          background-size cover
          &.active
            background url('./star-s.png') no-repeat;
            background-size cover
        .star-two
          position absolute
          left 50%
          bottom 188px
          transform translateX(-50%)
          width 78px
          height 75px
          background url('./star-b-g.png') no-repeat;
          background-size cover
          &.active
            background url('./star-b.png') no-repeat;
            background-size cover
        .star-three
          position absolute
          right 260px
          bottom 160px
          width 57px
          height 57px
          background url('./star-s-g.png') no-repeat;
          background-size cover
          &.active
            background url('./star-s.png') no-repeat;
            background-size cover
      .head
        position relative
        display flex
        justify-content center
        height 60px
        margin  56px 30px
        .back-wrapper
            position absolute
            left 0
            top 0
            width: 60px
            height: 60px
            .back-icon
                width: 60px
                height: 60px
        .head-content
          display flex
          align-items center
          .avatar
              width 53px
              height 53px
              border-radius 50%
              overflow hidden
              margin-right 24px
              .avatar-icon
                display block
                width 53px
                height 53px
                border-radius 50%
          .title
            font-size: 32px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 53px;
    .footer
      position fixed
      left 0
      bottom 0
      width 100%
      padding 10px
      background: #FFFFFF;
      box-shadow: 0 -1px 0 0 #EEEEEE;
      .btn
        display flex
        align-items center
        justify-content center
        height 80px
        background-image: linear-gradient(90deg, #FFC525 0%, #FFD929 100%);
        border-radius: 8px;
        font-size: 30px;
        color: #FFFFFF;
        .btn-score
          display flex
          align-items center
          justify-content center
          margin-left 40px
          .score-icon
            width 36px
            height 36px
            margin-left 12px
    .content
        flex 0 0 1
        margin-top -44px
        padding-bottom 164px
        background: #FFFFFF;
        border-radius: 32px 32px 0px 0px;
        .head
          padding 60px 30px 0
          text-align center
          .title
           line-height 50px
           font-family: PingFangSC-Semibold;
           font-size: 36px;
           color: #222222;
         .text
          line-height 40px
           margin-top 8px
           font-family: PingFangSC-Regular;
           font-size: 28px;
           color: #666666;
        .sutdy-time
          display flex
          justify-content center
          align-items center
          padding-top 40px
          .item+.item
            margin-left 130px
          .item
            text-align center
            font-size: 24px;
            color: #999999;
            .item-num
              display flex
              align-items baseline
              justify-content center
              .num
                font-size: 60px;
                font-family: SFUIDisplay-Bold, SFUIDisplay;
                font-weight: bold;
                color: #F78019;
                line-height: 71px;
              .num-text
                margin-left 8px
                font-size: 24px;
                font-family: SourceHanSansCN-Normal, SourceHanSansCN;
                font-weight: 400;
                color: #999999;
                line-height: 36px;
            .item-text
              line-height 40px
        .du-statistics {
          padding 60px 50px 0
          .du-title {
            text-align center
            padding-bottom 24px
            font-size: 34px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #222222;
            line-height: 48px;
          }
          .du-main {
            display:flex;
            align-items center;
            justify-content:space-between
            padding:20px 30px;
            background: #F8F6FC;
            border-radius: 24px;
            .du-item {
              display:flex;
              flex-direction:column;
              align-items center
              .du-item-top {
                font-size: 48px;
                font-family: SFUIDisplay-Medium, SFUIDisplay;
                font-weight: 500;
                color: #0093DD;
                line-height: 58px;
                span {
                  font-size: 24px;
                  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
                  font-weight: 400;
                  color: #999999;
                  line-height: 36px;
                }
              }
              .du-item-b {
                margin-top:6px
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                line-height: 40px;
              }
            }
          }
        }
        .line
          border-top 1px solid #eee
          margin 60px 50px 0
        .chart-wrapper
          padding 60px 50px 0
          .chart-head
            .title
              font-size: 34px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #222222;
              line-height: 48px;
              span
                color: #F78019;
            .code
              padding-top 32px
              .code-img
                display block
                width 258px
                height 258px
                margin 0 auto
            .share-btn
                display flex
                align-items center
                justify-content center
                width 380px
                height 80px
                margin 24px auto 0;
                border: 1px solid #EEEEEE;
                border-radius: 8px;
                .arrow
                  width 38px
                  height 38px
                  background url('./arrow.png') no-repeat;
                  background-size cover;
                .share-btn-text
                  font-family: PingFangSC-Medium;
                  font-size: 30px;
                  color: #FFA820;
            .list
              text-align left
              padding-top 8px
              .record-sound
                display flex
                align-items center
                width 320px
                height 60px
                padding-left 40px
                margin 32px auto 0;
                background: #DEF0FC;
                border-radius: 30px;
                font-family: Roboto-Regular;
                font-size: 24px;
                color: #3480FF;
              .item
                display flex
                align-items center
                padding-top 16px
                .tick-icon
                  width 30px
                  height 30px
                .item-text
                  flex:1;
                  margin-left 10px
                  font-size: 30px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #666666;
                  line-height: 42px;
</style>
